{
  "alert.informative": "Informativo",
  "alert.negative": "Negativo",
  "alert.notice": "Aviso",
  "alert.positive": "Positivo",
  "attachmentlist.nextAttachments": "Mostrar archivos adjuntos siguientes",
  "attachmentlist.previousAttachments": "Mostrar archivos adjuntos anteriores",
  "chat.newMessage": "Mensaje nuevo",
  "chat.scrollToBottom": "Desplazarse a la parte inferior",
  "messagefeedback.thumbDown": "Respuesta incorrecta",
  "messagefeedback.thumbUp": "Respuesta correcta",
  "promptfield.aiDisclaimer": "Las respuestas se generan mediante IA y pueden ser imprecisas. Compruébelas antes de utilizarlas.",
  "promptfield.aiUserGuidlines": "Directrices de usuario de IA",
  "promptfield.attachments": "Archivos adjuntos",
  "promptfield.insertButton": "Añadir",
  "promptfield.label": "Indicación",
  "promptfield.placeholder": "¿Listo para empezar? Formule una pregunta, comparta una idea o añada una tarea.",
  "promptfield.placeholder.small": "Preguntar cualquier cosa",
  "promptfield.stopButton": "Detener",
  "promptfield.submitButton": "Enviar",
  "promptfield.uploading": "Carga",
  "responsestatus.loading": "Cargando",
  "responsestatus.processing": "En proceso...",
  "voicebutton.startListening": "Iniciar grabación",
  "voicebutton.stopListening": "Detener grabación"
}
